import React from 'react';
import { PatternFormat, PatternFormatProps } from 'react-number-format';

interface CustomProps {
	onChange: (event: { target: { name: string; value: string } }) => void;
	name: string;
}

const AccountNumberFormat = React.forwardRef<PatternFormatProps, CustomProps>((props, ref) => {
	const { onChange, ...other } = props;

	return (
		<PatternFormat
			{...other}
			pattern='[0-9]*'
			inputMode='numeric'
			getInputRef={ref}
			onValueChange={(values) => {
				onChange({
					target: {
						name: props.name,
						value: values.value,
					},
				});
			}}
			format='########'
		/>
	);
});

AccountNumberFormat.displayName = 'AccountNumberFormat';

export default AccountNumberFormat;
